
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.53.584l5.664 5.774a.92.92 0 010 1.284l-5.665 5.774a.878.878 0 01-1.259 0 .92.92 0 010-1.283l4.146-4.226H.046V6.093h9.37L5.27 1.867a.92.92 0 010-1.283.878.878 0 011.26 0z","fill":"#fff"}})])
          )
        }
      }
    